module.exports = __webpack_public_path__ + "static/pow_lo-6b527a13166865648f0dfa89fc26a5a4.png";